import * as SalesLeadsModel from "./salesLeadsModel"

export type Action = 
  | { type: 'SALES_LEADS_ADDED', value: string }
  | { type: 'SALES_LEADS_CHANGED', serverSalesLeads: SalesLeadsModel.SalesLead[], value: string, salesLeadId: number }
  | { type: 'SALES_LEADS_DELETED', salesLeadId: number }
  | { type: 'SALES_LEADS_UNDELETED', salesLeadId: number }
  | { type: 'SALES_LEADS_SAVE' }

export const reducer = (state: SalesLeadsModel.SalesLeadsState, action: Action): SalesLeadsModel.SalesLeadsState => {
  switch(action.type) {
    case 'SALES_LEADS_ADDED':
      return SalesLeadsModel.addSalesLead(state, action.value)
    case 'SALES_LEADS_CHANGED':
      return SalesLeadsModel.updateSalesLead(state, action.serverSalesLeads, action.salesLeadId, x => ({ ...x, name: action.value  }))
    case 'SALES_LEADS_DELETED':
      return SalesLeadsModel.deleteSalesLead(state, action.salesLeadId)
    case 'SALES_LEADS_UNDELETED':
      return SalesLeadsModel.undeleteSalesLead(state, action.salesLeadId)
    case 'SALES_LEADS_SAVE':
      return SalesLeadsModel.defaultSalesLeadsState()
    default:
      return state
  }
}